export function validateThemeData({ name, theme_data }) {
  const errors = {};
  if (!name || !String(name).trim()) errors.name = 'Name is required';
  // theme_data is free-form; no deep validation by default
  return { valid: Object.keys(errors).length === 0, errors };
}
